import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TipologiaCostruttiva } from 'src/app/models/tipologia-costruttiva';
import { BaseEditForm } from 'src/app/shared/baseEditForm';


@Component({
  selector: 'tipologie-costruttive-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class TipologieCostruttiveFormComponent extends BaseEditForm implements OnInit {

  tipologiaCostruttiva: TipologiaCostruttiva;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<TipologieCostruttiveFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TipologiaCostruttiva,) {
    super();
    this.tipologiaCostruttiva = data;
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.tipologiaCostruttiva?.nome, Validators.required],
      descrizione: [this.tipologiaCostruttiva?.descrizione],
    });
  }

}

